<template>
  <FullScreenPopup
    ref="popup"
    title="Пошук даних клієнта"
    :lock-scroll="true"
    @visibility-change="onVisibilityChange"
  >
    <div class="fill-data-popup__content">
      <LabeledPolicyholderSelector
        class="fill-data-popup__selector fill-data-popup__policyholder-selector"
        label="1. Введіть ПІБ або ІПН клієнта"
        placeholder="ПІБ або ІПН клієнта"
        empty-state-text="Нічого немає"
        :auto-select-single="true"
        :policyholder-type="policyholderType"
        :policyholders-list="getPolicyholders"
        v-model="policyholder"
        @select="onSelectPolicyholder"
      />
      <LabeledPetsList
        class="fill-data-popup__selector fill-data-popup__pets-list"
        label="2. Оберіть тварину клієнта зі списку"
        placeholder="Оберіть тварину"
        :is-disabled="!policyholder"
        empty-state-text="Нічого немає"
        :select-first-pet="true"
        :pet="selectedPetId"
        :pets="getPolicyholderPets"
        v-model="pet"
      />
      <LabeledPolicyholderDocumentsList
        class="fill-data-popup__selector fill-data-popup__policyholder-documents-list"
        label="3. Оберіть необхідний документ"
        placeholder="Оберіть документ"
        :is-disabled="!policyholder"
        empty-state-text="Нічого немає"
        :select-first-document="false"
        :document-id="selectedDocumentId"
        :documents-list="getPolicyholderDocuments"
        v-model="document"
      />

      <BlueButton
        class="fill-data-popup__submit-btn"
        :is-disabled="!policyholder"
        @click="onFillData"
      >
        Підтвердити
      </BlueButton>
    </div>
  </FullScreenPopup>
</template>

<script>
import { documentTypes, LabeledPolicyholderDocumentsList, LabeledPolicyholderSelector, LabeledPetsList } from '@/features/selectors';
import { BlueButton } from '@/shared/ui/form';
import { FullScreenPopup } from '@/shared/ui/popup';

export default {
  props: {
    policyholderType: {
      type: String,
      default: 'natural',
    },
    policyholderData: {
      type: Object,
      default: null,
    },
    petsList: {
      type: Array,
      default: () => [],
    },
    selectedPetId: {
      type: [String, Number],
      default: null,
    },
    documentsList: {
      type: Array,
      default: () => [],
    },
    selectedDocumentId: {
      type: [String, Number],
      default: null,
    },
    allowedDocumentTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      policyholder: null,
      pet: null,
      document: null,
    };
  },
  computed: {
    getPolicyholders() {
      if (typeof this.policyholderData === 'object') {
        return [this.policyholderData];
      }

      return [];
    },
    getPolicyholderPets() {
      return this.policyholder?.pets || this.petsList || [];
    },
    getPolicyholderDocuments() {
      const docs = this.policyholder?.documents || this.documentsList || [];
      if (!this.allowedDocumentTypes || this.allowedDocumentTypes.length === 0) {
        return docs;
      }
      const allowedIds = this.allowedDocumentTypes.map(id =>
        typeof id === 'object' ? id.id : id
      );
      return docs.filter(doc => {
        const normalizedType = typeof doc.document_type === 'number'
          ? documentTypes.find(d => d.uid === doc.document_type)?.id
          : doc.document_type;
        return allowedIds.includes(normalizedType);
      });
    },
  },
  components: {
    FullScreenPopup,
    LabeledPolicyholderSelector,
    LabeledPetsList,
    LabeledPolicyholderDocumentsList,
    BlueButton,
  },
  methods: {
    open() {
      if (this.policyholderData) {
        this.policyholder = this.policyholderData;
      }

      this.$refs.popup.open();
    },
    close() {
      this.clear();

      this.$refs.popup.close();
    },
    clear() {
      this.policyholder = null;
      this.pet = null;
      this.document = null;
    },
    onVisibilityChange({ id, isVisible }) {
      if (!isVisible) {
        this.clear();
      }

      if (id === this.$refs.popup.getPopupId) {
        this.$emit('visibility-change', { id, isVisible });
      }
    },
    onSelectPolicyholder(policyholder) {
      this.policyholder = policyholder;
    },
    onFillData() {
      this.$emit('fillPolicyholderData', {
        policyholder: this.policyholder,
        pet: this.pet,
        document: this.document,
      });

      this.close();
    },
  },
};
</script>

<style scoped lang="scss">
.fill-data-popup {
  &__content {
    display: flex;
    flex-direction: column;
    padding: 16px;
    min-width: 350px;
  }

  &__selector {
    margin-bottom: 16px;
  }
}

::v-deep .fullscreen-popup__content-wrapper .fullscreen-popup__scroll-content {
  overflow: visible;
}

::v-deep .fullscreen-popup__content-wrapper {
  max-width: 500px;
}
</style>
